/* Plumme — touch-bro for HTML5 drag and drop.
 *
 * Nettlesere på mobil og nettbrett implementerer ikke HTML5-dragging: `draggable`,
 * `dragstart`, `dragover` og `drop` fyres aldri fra en finger. All drag-and-drop i
 * appen — bilag fra innboksen til en bankline, bilag til en føring, produktlinjer
 * inn i kundechatten, omrokkering av fakturalinjer — virker derfor bare med mus.
 *
 * Denne fila oversetter en fingerbevegelse til de samme hendelsene, slik at hver
 * enkelt side kan beholde sin vanlige HTML5-kode uten touch-spesifikke greiner.
 *
 * Kjøres som vanlig script (ikke Babel), lastes i head før jsx-filene.
 *
 * Aktivering: press og hold (~260 ms) på et element med draggable="true". Holder
 * vi ikke på scroll-gesten fram til da, ville listen scrollet i stedet for å dra.
 * Etter aktivering blokkeres scrolling med preventDefault på touchmove — den må
 * være non-passive, ellers ignorerer nettleseren den.
 */
(function (global) {
  'use strict';

  var LONG_PRESS_MS = 260;
  var MOVE_SLOP = 10;      // finger må stå nesten stille til aktivering
  var EDGE = 64;           // kantsone for auto-scroll under drag
  var EDGE_STEP = 14;

  var source = null;       // elementet vi drar
  var transfer = null;
  var ghost = null;
  var armTimer = 0;
  var edgeTimer = 0;
  var scroller = null;
  var dropTarget = null;   // siste element som godtok draget
  var startX = 0, startY = 0, lastX = 0, lastY = 0;
  var armed = false;

  function makeTransfer() {
    try { return new DataTransfer(); } catch (e) {}
    // iOS-Safari under 14.1 har ikke konstruktøren — minimumsversjon holder,
    // sidene bruker bare setData/getData/effectAllowed.
    var store = {};
    return {
      effectAllowed: 'all', dropEffect: 'move',
      types: [],
      files: [],
      setData: function (type, value) { store[type] = String(value); if (this.types.indexOf(type) < 0) this.types.push(type); },
      getData: function (type) { return store[type] || ''; },
      clearData: function (type) { if (type) delete store[type]; else store = {}; },
      setDragImage: function () {},
    };
  }

  function fire(type, target, x, y) {
    if (!target) return null;
    var init = { bubbles: true, cancelable: true, clientX: x, clientY: y, view: global };
    var event;
    try {
      init.dataTransfer = transfer;
      event = new DragEvent(type, init);
    } catch (e) {
      event = new MouseEvent(type, init);
      try { Object.defineProperty(event, 'dataTransfer', { value: transfer }); } catch (e2) {}
    }
    target.dispatchEvent(event);
    return event;
  }

  function scrollParent(el) {
    for (var node = el; node && node !== document.body; node = node.parentElement) {
      var style = getComputedStyle(node);
      var overflow = style.overflowY;
      if ((overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight) return node;
    }
    return null;
  }

  function makeGhost(el) {
    var rect = el.getBoundingClientRect();
    var clone = el.cloneNode(true);
    clone.className = (clone.className || '') + ' touchdrag-ghost';
    clone.style.width = Math.min(rect.width, 320) + 'px';
    clone.style.height = rect.height > 140 ? '140px' : rect.height + 'px';
    document.body.appendChild(clone);
    return clone;
  }

  function moveGhost(x, y) {
    if (ghost) ghost.style.transform = 'translate(' + (x - 40) + 'px,' + (y - 24) + 'px)';
  }

  function edgeScroll() {
    if (!scroller) return;
    var rect = scroller.getBoundingClientRect();
    if (lastY < rect.top + EDGE) scroller.scrollTop -= EDGE_STEP;
    else if (lastY > rect.bottom - EDGE) scroller.scrollTop += EDGE_STEP;
  }

  function cleanup() {
    if (armTimer) { clearTimeout(armTimer); armTimer = 0; }
    if (edgeTimer) { clearInterval(edgeTimer); edgeTimer = 0; }
    if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
    if (source) source.classList.remove('touchdrag-source');
    ghost = null; source = null; transfer = null; scroller = null; dropTarget = null; armed = false;
  }

  function arm() {
    armTimer = 0;
    if (!source) return;
    armed = true;
    transfer = makeTransfer();
    var started = fire('dragstart', source, startX, startY);
    if (started && started.defaultPrevented) { cleanup(); return; }
    source.classList.add('touchdrag-source');
    ghost = makeGhost(source);
    moveGhost(startX, startY);
    scroller = scrollParent(source);
    edgeTimer = setInterval(edgeScroll, 60);
    if (global.navigator && navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
  }

  function onTouchStart(event) {
    if (event.touches.length !== 1) return;
    var el = event.target;
    var candidate = el && el.closest ? el.closest('[draggable="true"]') : null;
    if (!candidate) return;
    cleanup();
    source = candidate;
    startX = lastX = event.touches[0].clientX;
    startY = lastY = event.touches[0].clientY;
    armTimer = setTimeout(arm, LONG_PRESS_MS);
  }

  function onTouchMove(event) {
    if (!source) return;
    var touch = event.touches[0];
    lastX = touch.clientX; lastY = touch.clientY;
    if (!armed) {
      // Beveger fingeren seg før aktivering er dette en scroll, ikke et drag.
      if (Math.abs(lastX - startX) > MOVE_SLOP || Math.abs(lastY - startY) > MOVE_SLOP) cleanup();
      return;
    }
    event.preventDefault();   // holder siden i ro mens vi drar
    moveGhost(lastX, lastY);
    if (ghost) ghost.style.display = 'none';
    var under = document.elementFromPoint(lastX, lastY);
    if (ghost) ghost.style.display = '';
    if (!under) return;
    if (dropTarget && !dropTarget.contains(under)) { fire('dragleave', dropTarget, lastX, lastY); dropTarget = null; }
    var over = fire('dragover', under, lastX, lastY);
    // preventDefault på dragover er HTML5-måten å si «her kan du slippe»
    if (over && over.defaultPrevented) {
      if (dropTarget !== under) fire('dragenter', under, lastX, lastY);
      dropTarget = under;
    } else if (dropTarget === under) {
      dropTarget = null;
    }
  }

  function onTouchEnd(event) {
    if (!source) return;
    if (!armed) { cleanup(); return; }
    event.preventDefault();
    var target = dropTarget;
    var droppedSource = source;
    if (target) fire('drop', target, lastX, lastY);
    fire('dragend', droppedSource, lastX, lastY);
    cleanup();
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchmove', onTouchMove, { passive: false });
  document.addEventListener('touchend', onTouchEnd, { passive: false });
  document.addEventListener('touchcancel', cleanup, { passive: true });

  global.PlummeTouchDrag = { active: function () { return armed; } };
})(window);
